import { Stack, Typography, styled } from '@mui/material';
import PropTypes from 'prop-types';
import DropdownSelect from 'components/commons/DropdownSelect';
import RpRangeSelect from 'components/commons/RpRangeSelect';

const StyledIcon = styled('div')(({ theme }) => ({
    fontSize: '21px',
    color: theme.palette.tertiary.main,
}));

const RpBasicRangeFilter = ({isDropdown = true, ...props}) => {

    const content = (
        <>
            <Stack direction="row" spacing={1} mb={2} alignItems="center">
                {props.icon && !isDropdown && <StyledIcon><props.icon style={{fontSize: '21px'}} /></StyledIcon>}
                <Typography variant="text1" gutterBottom mb={1}>{props.label}</Typography>
            </Stack>
            <RpRangeSelect
                minOptions={props.minOptions}
                maxOptions={props.maxOptions}
                minValue={props.minValue}
                maxValue={props.maxValue}
                onChange={props.onChange}
                sx={!isDropdown ? { width: '100%' } : null}
            />
        </>
    );

    return isDropdown ? (
        <DropdownSelect
            label={props.label}
            value={props.displayValue}
            width={props.width || 113}
            WithIcon={props.icon}
            active={props.active}
        >
            {content}
        </DropdownSelect>
    ) : content;
};

RpBasicRangeFilter.propTypes = {
    label: PropTypes.string.isRequired,
    minOptions: PropTypes.array,
    maxOptions: PropTypes.array,
    minValue: PropTypes.any,
    maxValue: PropTypes.any,
    onChange: PropTypes.func,
    displayValue: PropTypes.any,
    width: PropTypes.number,
    icon: PropTypes.elementType,
    active: PropTypes.bool,
    isDropdown: PropTypes.bool,
};

export default RpBasicRangeFilter;